<template>
  <div class="customers">
    <div class="page__header">
      <div class="page__title">{{ $t(`pageTitles.${"potential"}`) }}</div>
      <div class="page__right">
        <div class="selected-filters"
          v-if="selectedTeams.length > 0 || Object.keys(searchPotentialCustomerForms).length > 0">
          <div class="selected-filters__filter" v-for="teamId in selectedTeams" :key="`team${teamId}`">
            <span>
              Team: {{
                (loggedUser.teams && loggedUser.teams.find(t => t.id == teamId))
                  ? loggedUser.teams.find(t => t.id == teamId).name
                  : 'Team ' + teamId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeTeam(teamId)"></div>
          </div>

          <div class="selected-filters__filter" v-if="startDateFrom || startDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyStartDate"}`) }}: {{ formatDate(startDateFrom) || '...' }} - {{
              formatDate(startDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearStartDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="endDateFrom || endDateTo">
            <span>{{ $t(`searchCustomerFields.${"policyEndDate"}`) }}: {{ formatDate(endDateFrom) || '...' }} - {{
              formatDate(endDateTo) || '...' }}</span>
            <div class="selected-filters__remove" @click="clearEndDateRange()"></div>
          </div>

          <div class="selected-filters__filter" v-if="birthday">
            <span>{{ $t('searchCustomerFields.birthday') }}: {{ birthday }}</span>
            <div class="selected-filters__remove" @click="clearBirthday()"></div>
          </div>

          <div class="selected-filters__filter" v-if="zipFrom || zipTo">
            <span>{{ $t('searchCustomerFields.zip') }}: {{ formatRange(zipFrom, zipTo) }}</span>
            <div class="selected-filters__remove" @click="clearZip()"></div>
          </div>

          <div class="selected-filters__filter" v-for="agentId in selectedAgents" :key="`agent${agentId}`">
            <span>
              {{
                (searchPotentialCustomerForms.agents && searchPotentialCustomerForms.agents.find(a => a.id == agentId))
                  ? searchPotentialCustomerForms.agents.find(a => a.id == agentId).first_name + ' ' +
                  searchPotentialCustomerForms.agents.find(a => a.id == agentId).last_name
                  : 'Agent ' + agentId
              }}
            </span>
            <div class="selected-filters__remove" @click="removeAgent(agentId)"></div>
          </div>


          <div class="selected-filters__filter" v-for="typeId in selectedCompanyTypes" :key="`type${typeId}`">
            <span>{{
              (searchPotentialCustomerForms.companyTypes && searchPotentialCustomerForms.companyTypes.find(item => item.id === typeId))
                ? searchPotentialCustomerForms.companyTypes.find(item => item.id === typeId).type
                : 'Type ' + typeId
            }}</span>
            <div class="selected-filters__remove" @click="removeCompanyType(typeId)"></div>
          </div>


          <div class="selected-filters__filter" v-for="categoryId in selectedBranchCategories"
            :key="`category${categoryId}`">
            <span>{{
              (searchPotentialCustomerForms.branchCategories && searchPotentialCustomerForms.branchCategories.find(item => item.id === categoryId))
                ? searchPotentialCustomerForms.branchCategories.find(item => item.id === categoryId)[`long_${language}`]
                : 'Category ' + categoryId
            }}</span>
            <div class="selected-filters__remove" @click="removeBranchCategory(categoryId)"></div>
          </div>

          <div class="selected-filters__filter" v-for="priorityId in selectedPriorities" :key="`priority${priorityId}`">
            <span>{{
              (searchPotentialCustomerForms.priorities && searchPotentialCustomerForms.priorities.find(item => item.id === priorityId))
                ? searchPotentialCustomerForms.priorities.find(item => item.id === priorityId).type
                : 'Priority ' + priorityId
            }}</span>
            <div class="selected-filters__remove" @click="removePriority(priorityId)"></div>
          </div>

        </div>
        <form class="search search--filter" @submit.prevent="updateQuery()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="selected-filters__filter search__placeholder" v-if="searchPlaceholder">
              <div class="search__placeholder-content">
                {{ searchPlaceholder }}
                <div class="selected-filters__remove" @click="removeSearch()"></div>
              </div>
            </div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = true"></div>
          <SearchFilter v-if="showSearchFilter" :filterToggler="$refs.filterToggler" :searchType="'potentialCustomer'"
            :toggleSearchFilter="(state) => {
                showSearchFilter = state;
              }
              " />
        </form>
        <button type="button" class="button button--default button--animated"
          @click="$store.commit('setShowSearchPotentialCustomerModal', true)">
          <div class="button__icon"></div>
        </button>
      </div>
    </div>
    <div class="customers__content">
      <Loading v-if="customersLoading" />
      <PotentialPoliciesTable v-else :customers="customersPerPage.data || []" @refresh="searchCustomers" />
    </div>
    <Pagination :limit="3" :data="customersPerPage" @pagination-change-page="getResults"></Pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PotentialPoliciesTable from "@/components/PotentialPoliciesTable";
import Loading from "@/partials/Loading";
import SearchFilter from "@/partials/SearchFilter";

export default {
  name: "PotentialCustomers",

  components: {
    PotentialPoliciesTable,
    Loading,
    SearchFilter,
  },

  data() {
    return {
      searchPlaceholder: "",
      searchKeywords: "",
      showSearchFilter: false,
      selectedTeams: [],
      selectedAgents: [],
      selectedBranchCategories: [],
      selectedCompanyTypes: [],
      selectedPriorities: [],
      startDateFrom: "",
      startDateTo: "",
      endDateFrom: "",
      endDateTo: "",
      birthday: "",
      zipFrom: "",
      zipTo: "",
      initialLoadDone: false,
    };
  },

  watch: {
    "$route.query": {
      handler(query) {
        if (!query.page) {
          this.$router.replace({ query: { ...query, page: 1 } });
          return;
        }
        this.loadFiltersFromQuery(query);

        this.searchCustomers();
      },
      deep: true,
      immediate: true
    },
  },

  computed: {
    ...mapGetters([
      "customersPerPage",
      "customersLoading",
      "searchPotentialCustomerForms",
      "language",
      "loggedUser",
    ]),
  },

  async created() {
    const hasAccess = this.$checkRolePermission("customer_access") || this.$checkRolePermission("customer_show");

    if (!hasAccess) {
      this.$router.push("/dashboard");
      return;
    }

    try {
      const queryTeams = this.$route.query.teams ? this.$route.query.teams.split(",").map(Number) : [];

      if (queryTeams.length > 0) {
        await this.$store.dispatch("getSearchPotentialCustomerForms", queryTeams);
      } else if (this.loggedUser.teams && this.loggedUser.teams.length === 1) {
        await this.$store.dispatch("getSearchPotentialCustomerForms", [this.loggedUser.teams[0].id]);
      }
    } catch (error) {
      console.error("Error loading potential customer forms:", error);
    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);

      return `${day}/${month}/${year}`;
    },

    formatRange(from, to) {
      if (!from && !to) return '';
      if (from && !to) return `${from} - ...`;
      if (!from && to) return `... - ${to}`;
      return `${from} - ${to}`;
    },

    loadFiltersFromQuery(q) {
      this.searchKeywords = q.search || "";
      this.selectedTeams = q.teams ? q.teams.split(",").map(Number) : [];
      this.selectedAgents = q.agents ? q.agents.split(",").map(Number) : [];
      this.selectedBranchCategories = q.branchCategories ? q.branchCategories.split(",").map(Number) : [];
      this.selectedCompanyTypes = q.companyTypes ? q.companyTypes.split(",").map(Number) : [];
      this.selectedPriorities = q.priorities ? q.priorities.split(",").map(Number) : [];
      this.startDateFrom = q.startDateFrom || "";
      this.startDateTo = q.startDateTo || "";
      this.endDateFrom = q.endDateFrom || "";
      this.endDateTo = q.endDateTo || "";
      this.birthday = q.birthday || "";
      this.zipFrom = q.zip_from || "";
      this.zipTo = q.zip_to || "";
    }, 

    searchCustomers() {
      this.$store.commit("setCustomersLoading", true);
 
      const page = Number(this.$route.query.page) || 1;
      const teamsFromUrl = this.$route.query.teams;
      const teams = teamsFromUrl ? teamsFromUrl.split(",").map(Number) : [];

      const payload = {
        search: this.searchKeywords,
        page: page,
        teams: teams,
        agents: this.selectedAgents,
        branchCategories: this.selectedBranchCategories,
        companyTypes: this.selectedCompanyTypes,
        priorities: this.selectedPriorities,
        startDateFrom: this.startDateFrom,
        startDateTo: this.startDateTo,
        endDateFrom: this.endDateFrom,
        endDateTo: this.endDateTo,
        zip_from: this.zipFrom,
        zip_to: this.zipTo,
        birthday: this.birthday
      };

      this.$store.dispatch("searchPotentialCustomers", payload)
        .then(() => {
          if (this.customersPerPage.data && this.customersPerPage.data.length === 0 && page > 1) {
            this.getResults(page - 1);
          }
        })
        .catch(error => {
          console.error("Search failed:", error);
        })
        .finally(() => {
          this.$store.commit("setCustomersLoading", false);
        });
    },

    updateQuery() {
      this.$router.replace({
        query: {
          page: 1,
          search: this.searchKeywords || undefined,
          teams: this.selectedTeams.length ? this.selectedTeams.join(",") : undefined,
          agents: this.selectedAgents.length ? this.selectedAgents.join(",") : undefined,
          branchCategories: this.selectedBranchCategories.length ? this.selectedBranchCategories.join(",") : undefined,
          companyTypes: this.selectedCompanyTypes.length ? this.selectedCompanyTypes.join(",") : undefined,
          priorities: this.selectedPriorities.length ? this.selectedPriorities.join(",") : undefined,
          startDateFrom: this.startDateFrom || undefined,
          startDateTo: this.startDateTo || undefined,
          endDateFrom: this.endDateFrom || undefined,
          endDateTo: this.endDateTo || undefined,
          birthday: this.birthday || undefined,
          zip_from: this.zipFrom || undefined,
          zip_to: this.zipTo || undefined,
        },
      }).catch(() => { });
    },

    clearAllDependentFilters() {
      this.selectedAgents = [];
      this.selectedBranchCategories = [];
      this.selectedCompanyTypes = [];
      this.selectedPriorities = [];
      this.birthday = "";
      this.zipFrom = "";
      this.zipTo = "";
      this.startDateFrom = "";
      this.startDateTo = "";
      this.endDateFrom = "";
      this.endDateTo = "";

      this.$store.commit("setSearchPotentialCustomerForms", {});
    },

    clearStartDateRange() {
      this.startDateFrom = "";
      this.startDateTo = "";
      this.updateQuery();
    },

    clearEndDateRange() {
      this.endDateFrom = "";
      this.endDateTo = "";
      this.updateQuery();
    },

    clearBirthday() {
      this.birthday = "";
      this.updateQuery();
    },

    clearZip() {
      this.zipFrom = "";
      this.zipTo = "";
      this.updateQuery();
    },

    removeTeam(id) {
      this.selectedTeams = this.selectedTeams.filter((x) => x !== id);

      if (this.selectedTeams.length === 0) {
        this.clearAllDependentFilters();
      }

      this.updateQuery();
    },

    removeAgent(id) {
      this.selectedAgents = this.selectedAgents.filter((x) => x !== id);
      this.updateQuery();
    },

    removeCompanyType(id) {
      this.selectedCompanyTypes = this.selectedCompanyTypes.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    removeBranchCategory(id) {
      this.selectedBranchCategories = this.selectedBranchCategories.filter(
        (x) => x !== id
      );
      this.updateQuery();
    },

    removePriority(id) {
      this.selectedPriorities = this.selectedPriorities.filter((x) => x !== id);
      this.updateQuery();
    },

    removeSearch() {
      this.searchKeywords = "";
      this.updateQuery();
    },

    getResults(page) {
      if (Number(this.$route.query.page) === Number(page)) return;

      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.customers {
  height: 100%;

  &__content {
    margin-bottom: 20px;
    height: calc(100% - 48px - 15px - 16px - 20px);
  }
}
</style>
